import React, { useCallback, useEffect, useRef } from 'react';
import {
  useElement,
  focusEditor,
  mergeProps,
  useEditorRef,
  useHotkeys,
  floatingMediaActions,
  floatingMediaSelectors,
  submitFloatingMedia,
  select,
} from '@udecode/plate';
import clsx from 'clsx';

import { RemoveNodeButton } from '../../components/button/RemoveNodeButton';

export const PlateFloatingMedia = () => {
  const element = useElement();

  return (
    <div
      className={clsx(
        'slate-ui-floating',
      )}
    >
      <div className="slate-ui-floating__inner slate-ui-floating__inner--single-button">
        <RemoveNodeButton
          element={element}
          className="slate-ui-floating__button"
        />
      </div>
    </div>
  );
};

export const useFloatingMediaEditButton = (props) => {
  const element = useElement();

  return {
    onClick: useCallback(() => {
      floatingMediaActions.url(element.url);
      floatingMediaActions.isEditing(true);
    }, [element.url]),
    ...props,
  };
};

export const FloatingMediaEditButton = (props) => {
  const { className, ...rest } = props;
  const htmlProps = useFloatingMediaEditButton(rest);
  htmlProps.className = clsx(
    className,
    'slate-ui-floating__button',
    'button--unstyled',
  );

  return (
    <button {...htmlProps} />
  );
};

export const useFloatingMediaUrlInput = ({
  pluginKey,
  ...props
}) => {
  const editor = useEditorRef();
  const element = useElement();
  const location = useRef();

  useEffect(() => {
    // Set location of embed to use later to refocus on outside click.
    if (editor.selection) location.current = editor.selection.anchor.path;

    return () => {
      select(editor, location.current);
      submitFloatingMedia(editor, { element, pluginKey });
      floatingMediaActions.isEditing(false);
    };
  }, []);

  useHotkeys(
    'enter',
    (e) => {
      if (submitFloatingMedia(editor, { element, pluginKey })) {
        e.preventDefault();
      }
    },
    {
      enableOnFormTags: ['INPUT'],
    },
    [],
  );

  useHotkeys(
    'escape',
    () => {
      if (floatingMediaSelectors.isEditing()) {
        floatingMediaActions.reset();
        focusEditor(editor, editor.selection);
      }
    },
    {
      enableOnFormTags: ['INPUT'],
      enableOnContentEditable: true,
    },
    [],
  );

  const onChange = useCallback((e) => {
    floatingMediaActions.url(e.target.value);
  }, []);

  return mergeProps(
    {
      onChange,
      autoFocus: true,
      defaultValue: floatingMediaSelectors.url(),
    },
    props,
  );
};

export const FloatingMediaUrlInput = (props) => {
  const htmlProps = useFloatingMediaUrlInput(props);

  return (
    <input {...htmlProps} />
  );
};
